import { queryOptions, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AdaptivePlannerPlan } from '@/lib/api/adaptive-planner/plan';
import type { Plan } from '@/lib/api/types/adaptivePlanner';
import { adaptivePlannerQueryKeys } from '@/lib/query-keys/adaptivePlanner';
import { associateById } from '@/lib/utils/common/associateById';

export const planQueryOptions = ({ enabled, limit }: { enabled?: boolean; limit?: number } = {}) =>
  queryOptions<Plan[]>({
    queryKey: [...adaptivePlannerQueryKeys.plans.all(), { limit }],
    queryFn: () => AdaptivePlannerPlan.getPlans({ limit }),
    enabled: enabled ?? true,
  });

export const useGetPlansQuery = (
  options: Partial<UseQueryOptions<Plan[]>> & { limit?: number } = {},
) => {
  const { limit, ...queryOptions } = options;
  return useQuery({
    ...planQueryOptions({
      enabled: queryOptions.enabled ? queryOptions.enabled === true : true,
      limit,
    }),
    ...queryOptions,
  });
};

export const useGetPlansByIdQuery = (options: Partial<UseQueryOptions<Plan[]>> = {}) => {
  return useQuery({
    ...planQueryOptions({ enabled: options.enabled ? options.enabled === true : true }),
    ...options,
    select: associateById,
  });
};
